<template>
  <div>

    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div>
        <!-- <validation-observer ref="observer" v-slot="{ handleSubmit }"> -->
          <!-- <b-form id="manage_from" class="form theme-form datepicker-responsive"> -->
          <b-overlay  rounded="sm">
            <productListing  ref="production" v-show="!isShowDetail" :supplierId="supplierId" :selectTab="productListTab" :fromAdmin="true" :submit-type="submitType" @row-click="handleProductRowClick"></productListing>
           
             <productDetailVue
             ref="manage_productDetail"
             v-if="isShowDetail&&supplierId&&temp_productId>0" 
             :key="`productDetail_${temp_productId}`" 
             :name="`manage_productDetail_${supplierId}`" 
             :supplierId="supplierId" 
             :ProductId="temp_productId" 
             :fromAdmin="true" 
             :submit-type="submitType"
             @hide-detail="handleHideDetail"
             @open-detail="handleOpenDetail"
             >
             </productDetailVue> 

              <indexDetailVue ref="manage_indexDetailVue" v-if="isShowDetail&&supplierId&&temp_catalogId>0" 
              :key="`indexDetail_${temp_productId}`" 
              :catalogId="temp_catalogId" 
              :fromAdmin="true"  
              :supplierId="supplierId"
              :submit-type="submitType"
              @hide-detail="handleHideDetail"
              @open-detail="handleOpenDetail"
              >
              </indexDetailVue>

           </b-overlay>
             
          <!-- </b-form>  -->
        <!-- </validation-observer> -->
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import { computed } from "vue";
import { mapGetters } from "vuex";
import productDetailVue from '../../NewproductInfoCenter/productDetail.vue';
import indexDetailVue from '../../NewproductInfoCenter/indexDetail.vue';
import { productService, unwrapProductListPayload } from '@/_services/product.service';
import { userService } from "@/_services";
import productListing from "../../NewproductInfoCenter/productlisting.vue";
import { clearAdminDetailFromRoute } from '@/_helpers/adminDeepLinkRoute';
export default {
  components: {
    productDetailVue,
    indexDetailVue,
    productListing,
   // product_index: 0, 
    //productcatalog_index: 0, 
  },
  props: ['supplierId','submitType'],
  data() {
    return {
      activeTab: 0, // 默认选中第一个 tab 
      visitedTabs: [],
      productList: [], 
      isProductLoaded:false,
      isCatalogLoaded:false,
      indexList: [],
      type: '',
      ParentClick:
      {
        state: false,
        CatalogueState:false
      },
      permissionData:null,
      temp_productId:0,
      temp_catalogId:0,
      isShowDetail:false,
      productListTab:0
    };
  },
  watch:{
    // supplierId:{
    //   handler(){
    //     this.refresh();
    //   }
    // }
  },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      const empCompanyId = this.user && this.user.empCompanyId;
      return this.supplierId === null || this.supplierId === undefined || this.supplierId === '' ? empCompanyId : this.supplierId;
    },
     ...mapGetters({
      getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    }),
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  mounted() {
    this.GetSysCompanySponsorType();
    // URL deep-link：进入产品 tab 后直接打开产品 / 目录详情
    const q = this.$route.query || {};
    if (q.productId) {
      this.handleProductRowClick({ productOrCatalogId: Number(q.productId), type: "product" });
    } else if (q.catalogId) {
      this.handleProductRowClick({ productOrCatalogId: Number(q.catalogId), type: "catalog" });
    }
  },
  created() {
    this.refresh();
  },
  methods: {
    handleProductRowClick({ productOrCatalogId,type }) {
      this.isShowDetail = true;
      if(type=='product'){
      this.temp_productId = productOrCatalogId;
      this.temp_catalogId=0;
      } 
     else if(type=='catalog'){
      this.temp_productId = 0;
      this.temp_catalogId=productOrCatalogId;
     } 
    },
    handleHideDetail(type) {
      // 隐藏详情页，显示列表页面
      this.isShowDetail = false;
      this.temp_productId = 0;
      this.temp_catalogId = 0;
      clearAdminDetailFromRoute(this.$router);
      this.$emit('detail-visibility-change', {
        isShowDetail: false,
        isProductDetail: false,
        isCatalogDetail: false,
        LanuchStatus:'',
      });
      // 可选：刷新列表数据
      // 使用 $nextTick 等待 DOM 更新完成后再访问 ref
      this.$nextTick(() => {
        if (this.$refs.production) {
          this.productListTab = type;
          this.$refs.production.fetchData && this.$refs.production.fetchData();
        }
      });
    }, 
    handleOpenDetail(type,LanuchStatus){
      this.$emit('detail-visibility-change', {
        isShowDetail: true,
        isProductDetail: type === 'product',
        isCatalogDetail: type === 'catalog',
        LanuchStatus:LanuchStatus
      });
    },
    refresh() {
      //this.loadData();
     // this.onInput(0);
      // if (this.$refs.productDetailVue) {
      //   this.$refs.productDetailVue.refresh();
      // }
      // if (this.$refs.indexDetailVue) {
      //   this.$refs.indexDetailVue.refresh();
      // }
    },
    onInput(value) {
      var type = "product";
      if (value === 1) {
        type = "productcatalog";
      }
      this.changeTabType(type, 0);
    },
    changeTabType(newType,productIdOrCatalogId, index) {
      this.type = newType;
      if (this.type === 'product') {
        this.product_index = index; 
        this.productId=productIdOrCatalogId;
      }
      if (this.type === 'productcatalog') {
        this.productcatalog_index = index;
        this.catalogId=productIdOrCatalogId
      }
    },
    loadData() {
      this.productList = [];
      this.indexList = [];
      //this.loadingProduct = true;
      //this.loadingCatalog = true;
      //获取数据
      productService.getProdutListAsync({ companyId: this.companyid, pageNumber: 1, pageSize: 9999 })
        .then((res) => {
          if (res.isSuccessful) {
            const { items } = unwrapProductListPayload(res.data);
            items.forEach((item,index) => {
              if(index==0){
                this.productId=item.productId
              }
              var _item = {
                id: item.productId,
                //name: item.exhibitNameS,
                name: this.langid == 1252 ? item.exhibitNameE : (this.langid == 936 ? item.exhibitNameS : item.exhibitNameT),
                IsLaunch: item.isLaunch,
                isFire: item.isMainProduct,
                EmpCompanyId: item.empCompanyId,
                OrderId: item.orderId,
                productId: item.productId,
                status:this.GetPageState(item.lastSubmitDate.replace('-',''),item.lastSaveDate.replace('-',''),item.isLaunch),
                lastSubmitDate: item.lastSubmitDate,
                lastSaveDate: item.lastSaveDate,
              };
              this.productList.push(_item);
            });
          }
        }).finally(() => {
          //this.loadingProduct = false;
          this.isProductLoaded=true;
        });
      //获取产品目录列表
      //console.log('getProdutCatalogListAsync'+this.companyid+'-'+this.langid );
      productService//.getProdutCatalogListAsync({ companyId: this.companyid })
      .getProdutCatalogListAsync({ companyId: this.companyid,langId: this.langid })
        .then((res) => {
          //console.log('获取产品目录列表');
          console.log(res);
          if (res.isSuccessful) {
            this.indexList = [];
            this.directory_LaunchedCount = 0;
            res.data.forEach((item,idx) => {
              //var currentLangId = localStorage.getItem('currentLangId');
              if(idx==0)
              {
                this.catalogId=item.catalogId;
              }
              var index = this.indexList.filter(c => c.id == item.catalogId);
              if (index.length <= 0) {
                var _item = {
                  id: item.catalogId,
                  name: item.name,
                  statusClass: item.isLaunch
                    ? 'badge-light-success'
                    : 'badge-light',
                  orederId: item.orderId,
                  spanIsLaunch: item.isLaunch,
                  lastSaveDate: item.saveDate,
                  lastSubmitDate: item.submitDate
                };
                if (_item.spanIsLaunch) {
                  this.directory_LaunchedCount += 1;
                }
                this.indexList.push(_item);
              }
            });
            console.log('indeli', this.indexList);
          }
        }).finally(() => {
          //this.loadingCatalog = false;
          this.isCatalogLoaded=true;
        });
    },
    todoSaveSubmit() {
      if (this.type === 'product') {
        //this.$refs.manage_productDetail[this.product_index].SaveOrSubmitByStatus();
         this.$refs.manage_productDetail[0].SaveOrSubmitByStatus(this.submitType);  
      }
      if (this.type === 'productcatalog') {
        //this.$refs.manage_productDetail[this.productcatalog_index].todoSubmit();
        this.$refs.manage_indexDetailVue[0].SaveOrSubmitByStatus(this.submitType); 
      }
    },
    getProductDetailRef() {
      const ref = this.$refs.manage_productDetail;
      if (!ref) return null;
      return Array.isArray(ref) ? ref[0] : ref;
    },
    /** 审批模式：保存驳回内容（转发产品详情） */
    saveApprovalRejectContent() {
      const detail = this.getProductDetailRef();
      if (detail && typeof detail.saveApprovalRejectContent === 'function') {
        return detail.saveApprovalRejectContent();
      }
      return Promise.resolve(false);
    },
    /** 审批模式：完成（通过/驳回弹窗逻辑在产品详情内） */
    finishProductApproval() {
      const detail = this.getProductDetailRef();
      if (detail && typeof detail.finishProductApproval === 'function') {
        return detail.finishProductApproval();
      }
      return Promise.resolve(false);
    },
     GetSysCompanySponsorType() {
      var that = this;
      console.log(this.companyid);
      if (this.companyid > 0) {
        userService
          .GetSysCompanySponsorType({ CompanyId: this.companyid })
          .then((res) => {
            if (res.isSuccessful) {
              var data = res.data;
              that.permissionData = this.getPermissionJsonByUser({ user: data });
            }
          });
      }
    },
     GetPageState(lastSubmitDate,lastSaveDate,isLaunch) {
     if (lastSubmitDate != '' && (isLaunch == true||isLaunch == 1)) { 
        //上架
        return 1;
      }
      else if (!lastSubmitDate||(lastSubmitDate&&lastSaveDate&&lastSaveDate>lastSubmitDate)) {
        //下架之后再次保存，状态变为草稿（新加）
        return 0 ;//草稿
      }
      else {
      
        return 2;//下架
      }
    },
     handleRowClick(row, column, event) {
      this.currentRow = row
      // 执行其他操作，如跳转详情页
      //this.$router.push(`/detail/${row.id}`)
    },
  },
    provide() {
    return {
      permissionData: computed(() => this.permissionData),
      ChildSubmit: this.ParentClick
    };
  },
};
</script>
<style s>
.el-table__row{
  cursor: pointer;
}
</style>
<style >
 /* #manage_from .card-header:nth-child(1){
 margin-left: 15px !important ;
} */
 
.k-loader-container
{
  z-index: 999 !important;   
}

</style>